import { Params } from 'react-router-dom';
import { generatePath } from 'react-router';
import _ from 'lodash';
import { TAppRoute } from '../types/TAppRoute';
import AppRoutes from '../../../AppRoutes';

class HAppRoutes {
	static getPath = (routeTag: string, routeParams: Params | null = null) => {
		const allRoutes = _.flatten(AppRoutes.map((appsRoute) => Object.values(appsRoute))).filter(
			(x) => x.component !== null,
		);
		const routeConfig = allRoutes.find((x) => x.tag === routeTag);
		if (routeTag === null || typeof routeConfig === 'undefined') {
			return '';
		} else {
			return generatePath(routeConfig.path, routeParams ?? {});
		}
	};

	static getRoute = (routeTag: string) => {
		const allRoutes = _.flatten(AppRoutes.map((appsRoute) => Object.values(appsRoute))).filter(
			(x) => x.component !== null,
		) as TAppRoute[];
		const routeConfig = allRoutes.find((x) => x.tag === routeTag);
		if (routeTag === null || typeof routeConfig === 'undefined') {
			return null;
		} else {
			return routeConfig;
		}
	};

	static getRoutes = () => {
		return _.flatten(AppRoutes.map((route) => Object.values(route))).filter((x) => x.component !== null);
	};

	/**
	 * Vérifie que les routes ne sont pas duplicate sur les tag et paths
	 * @returns
	 */
	static checkRoutes = () => {
		const checkTags: string[] = [];
		const checkPaths: string[] = [];
		_.flatten(AppRoutes.map((route) => Object.values(route))).forEach((route) => {
			if (checkTags.includes(route.tag) || checkPaths.includes(route.path)) {
				throw new Error('Invalid route config for route tag : ' + route.tag + ' ou route path : ' + route.path);
			}
			checkTags.push(route.tag);
			checkPaths.push(route.path);
		});
		return true;
	};
}

export default HAppRoutes;
